module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/purchase/purchase-quotation/purchase-quotation-form/purchase-quotation-form.component.css
// module id = ./src/app/Pages/purchase/purchase-quotation/purchase-quotation-form/purchase-quotation-form.component.css
// module chunks = main